export default __webpack_public_path__ + "static/media/emblem.b8222556.png";